import { render, staticRenderFns } from "./AddNewRole.vue?vue&type=template&id=0555f019&scoped=true"
import script from "./AddNewRole.vue?vue&type=script&lang=js"
export * from "./AddNewRole.vue?vue&type=script&lang=js"
import style0 from "./AddNewRole.vue?vue&type=style&index=0&id=0555f019&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0555f019",
  null
  
)

export default component.exports